// src/components/StatusLegend.tsx
import { ApplicantStatus, CreatorStatus } from '../../types/enums.js';
import { StatusDot } from './StatusDot';

type StatusLegendProps = {
  type: 'applicant' | 'creator';
};

const formatStatusName = (status: ApplicantStatus | CreatorStatus): string => {
  return String(status).replace(/_/g, ' ');
};

export const StatusLegend = ({ type }: StatusLegendProps) => {
  const statuses = type === 'applicant' 
    ? [
        ApplicantStatus.APPLIED,
        ApplicantStatus.IN_REVIEW,
        ApplicantStatus.SAMPLE_REQUESTED,
        ApplicantStatus.OFFER_SENT,
        ApplicantStatus.REJECTED
      ]
    : [
        CreatorStatus.ACTIVE,
        CreatorStatus.SUSPENDED
      ];

  return (
    <div className="bg-gray-800 rounded-lg p-4 mt-4">
      <h3 className="text-sm font-medium text-gray-300 mb-3">Status Legend</h3>
      <div className="flex flex-wrap gap-4">
        {statuses.map(status => (
          <div key={status} className="flex items-center space-x-2">
            <StatusDot status={status} />
            <span className="text-sm text-gray-400">
              {formatStatusName(status)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};